import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import ReactResizeDetector from "react-resize-detector";
import { push } from "react-router-redux";
import { DropTarget } from "react-dnd";
import { connect } from "react-redux";
import { compose } from "redux";
import idx from "idx";
import { withFirebase } from "react-redux-firebase";
import Spinner from "react-spinkit";

import {
  MapWidget,
  MapConnector,
  Minimap,
  MapImage
} from "../../components/Map";
import Types from "../../dnd/types";
import {
  addPortalRequest,
  selectWidget,
  addConnectorRequest,
  updateWidgetRequest,
  removeWidget,
  updateMapRequest,
  removeConnectors,
  removeConnector,
  removeWidgetLocally,
  removeConnectorLocally
} from "../../redux/actions/map";
import { selectInspectorItem } from "../../redux/actions/inspector";
import { WIDGETS, EDITOR_ITEMS } from "../../constants";
import { prepareItems } from "../../helpers";
import Styles from "./MapContainer.styles";

import { mapConnectorModel, getDataFromModel } from "../../helpers/models";

class Map extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      imageScale: 0.01,
      imagePositionX: 0.5,
      imagePositionY: 0.5,
      widgets: props.widgets,
      connectors: props.connectors,
      newConnector: null,
      imageLoaded: false,
      zoom: 0,
      maxZoom: 0,
      initialScale: null,
      imageNaturalWidth: null,
      imageNaturalHeight: null
    };
    this.imageOnLoad = this.imageOnLoad.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.widgetOnSelect = this.widgetOnSelect.bind(this);
    this.widgetOnChangePosition = this.widgetOnChangePosition.bind(this);
    this.widgetOnStartConnect = this.widgetOnStartConnect.bind(this);
    this.connectorOnMouseMove = this.connectorOnMouseMove.bind(this);
    this.connectorOnMouseUp = this.connectorOnMouseUp.bind(this);
    this.widgetOnMouseDrop = this.widgetOnMouseDrop.bind(this);
    this.widgetOnMouseUp = this.widgetOnMouseUp.bind(this);
    this.onDropConnector = this.onDropConnector.bind(this);
    this.onZoomIn = this.onZoomIn.bind(this);
    this.onZoomOut = this.onZoomOut.bind(this);
    this.onConnectorRemove = this.onConnectorRemove.bind(this);

    this.onMinimapMove = this.onMinimapMove.bind(this);
    this.onMinimapClick = this.onMinimapClick.bind(this);

    this.onWidgetRemove = this.onWidgetRemove.bind(this);
    this.onLocalConnectorRemove = this.onLocalConnectorRemove.bind(this);

    this.imageWidth = 0;
    this.imageHeight = 0;
    this.imagePositionX = 0.5;
    this.imagePositionY = 0.5;
    this.imageScale = 0.01;
    this.editorWidth = 0;
    this.editorHeight = 0;
    this.grabX = 0;
    this.grabY = 0;
    this.grabLeft = 0;
    this.grabTop = 0;
    this.zoom = 1;

    this.newWidgetId = 0;
    this.newConnectorId = 0;
  }

  onWidgetRemove(snapshot) {
    const { projectId } = this.props.match.params;
    this.props.removeWidgetLocally(snapshot.key, projectId);
  }

  onLocalConnectorRemove(snapshot) {
    const { projectId } = this.props.match.params;
    this.props.removeConnectorLocally(snapshot.key, projectId);
  }

  componentWillMount() {
    const { projectId } = this.props.match.params;
    this.props.firebase
      .database()
      .ref(`/projects/${projectId}/map`)
      .child("widgets")
      .on("child_removed", this.onWidgetRemove);

    this.props.firebase
      .database()
      .ref(`/projects/${projectId}/map`)
      .child("connectors")
      .on("child_removed", this.onLocalConnectorRemove);
  }

  componentWillUnMount() {
    const { projectId } = this.props.match.params;
    this.props.firebase
      .database()
      .ref(`/projects/${projectId}/map`)
      .child("widgets")
      .off("child_added", this.onWidgetRemove);

    this.props.firebase
      .database()
      .ref(`/projects/${projectId}/map`)
      .child("connectors")
      .off("child_removed", this.onConnectorRemove);
  }

  componentWillReceiveProps(newProps) {
    // const { widgets, connectors } = this.state;
    const {
      widgets: newWidgets,
      connectors: newConnectors,
      selectedWidget
    } = newProps;

    let updatedState = {
      widgets: newWidgets,
      connectors: newConnectors
    };

    if (selectedWidget) {
      updatedState = { ...updatedState, selectedWidget };
    }
    if (newProps.mapImageUrl !== this.props.mapImageUrl) {
      updatedState = { ...updatedState, imageLoaded: false };
    }
    this.setState(updatedState);
  }

  onConnectorRemove(connectorId) {
    const { projectId } = this.props.match.params;
    this.props.removeConnector(connectorId, projectId);
  }

  onMinimapClick(imagePositionX, imagePositionY) {
    const imageWidthWithEmptySpace =
      this.imageWidth * this.imageScale +
      Math.max(
        0,
        (this.editorWidth - this.imageWidth * this.initialScale) *
          this.imageScale
      );
    const imageHeightWithEmptySpace =
      this.imageHeight * this.imageScale +
      Math.max(
        0,
        (this.editorHeight - this.imageHeight * this.initialScale) *
          this.imageScale
      );

    this.imagePositionX =
      ((imagePositionX - 0.5) * imageWidthWithEmptySpace * -1) /
      this.editorWidth;
    this.imagePositionY =
      ((imagePositionY - 0.5) * imageHeightWithEmptySpace * -1) /
      this.editorHeight;
    this.recalculate();
  }

  onMinimapMove(imagePositionX, imagePositionY) {
    const imageWidthWithEmptySpace =
      this.imageWidth * this.imageScale +
      Math.max(
        0,
        (this.editorWidth - this.imageWidth * this.initialScale) *
          this.imageScale
      );
    const imageHeightWithEmptySpace =
      this.imageHeight * this.imageScale +
      Math.max(
        0,
        (this.editorHeight - this.imageHeight * this.initialScale) *
          this.imageScale
      );

    this.imagePositionX =
      ((imagePositionX - 0.5) * imageWidthWithEmptySpace * -1) /
      this.editorWidth;
    this.imagePositionY =
      ((imagePositionY - 0.5) * imageHeightWithEmptySpace * -1) /
      this.editorHeight;
    this.recalculate();
  }

  onResize() {
    if (this.editor) {
      this.editorWidth = this.editor.offsetWidth;
      this.editorHeight = this.editor.offsetHeight;
      let scale = this.getImageScale();
      let { initialScale } = this.state;
      if (initialScale === null) {
        if (
          this.imageWidth / this.imageHeight <
          this.editorWidth / this.editorHeight
        ) {
          scale = this.editorHeight / this.imageHeight;
        } else {
          scale = this.editorWidth / this.imageWidth;
        }

        initialScale = scale;
        this.initialScale = initialScale;
        this.imageScale = initialScale;
      }

      const {
        imagePositionX,
        imagePositionY,
        imageScale,
        imageHeightWithEmptySpace,
        imageWidthWithEmptySpace
      } = this.fitMap();

      const zoom = this.state.zoom + 1;
      this.recalculate(zoom, {
        imagePositionX,
        imagePositionY,
        imageScale,
        imageHeightWithEmptySpace,
        imageWidthWithEmptySpace
      });
    }
  }

  onMouseDown(event) {
    if (event.nativeEvent.target === this.container) {
      event.nativeEvent.preventDefault();
      this.container.addEventListener("mousemove", this.onMouseMove);
      this.container.addEventListener("mouseup", this.onMouseUp);

      this.grabX = event.nativeEvent.screenX;
      this.grabY = event.nativeEvent.screenY;
      this.grabLeft = event.nativeEvent.target.offsetLeft;
      this.grabTop = event.nativeEvent.target.offsetTop;
    }
  }

  onMouseMove(event) {
    event.preventDefault();
    this.imagePositionX =
      (this.grabLeft + (event.screenX - this.grabX)) / this.editorWidth;
    this.imagePositionY =
      (this.grabTop + (event.screenY - this.grabY)) / this.editorHeight;
    this.recalculate();
  }

  onMouseUp(event) {
    event.preventDefault();
    this.container.removeEventListener("mousemove", this.onMouseMove);
    this.container.removeEventListener("mouseup", this.onMouseUp);
  }

  onWheel(event) {
    let scale =
      this.imageScale -
      Math.sign(event.nativeEvent.deltaY) * this.imageScale * 0.1;
    const zoom = Math.max(
      0,
      Math.min(
        this.state.zoom - Math.sign(event.nativeEvent.deltaY) * 1,
        this.state.maxZoom
      )
    );
    if (scale < 10) {
      scale = Math.min(scale, 10);
      const percentage = scale / this.imageScale;
      this.imageScale = scale;

      const originX = event.nativeEvent.clientX;
      const originY = event.nativeEvent.clientY;
      const box = this.container.getBoundingClientRect();
      const posX = box.left + box.width * 0.5;
      const posY = box.top + box.height * 0.5;

      const offsetX = (posX - originX) * percentage - (posX - originX);
      const offsetY = (posY - originY) * percentage - (posY - originY);

      this.imagePositionX =
        (this.container.offsetLeft + offsetX) / this.editorWidth;
      this.imagePositionY =
        (this.container.offsetTop + offsetY) / this.editorHeight;
      this.recalculate(zoom);
    }
  }

  onDropConnector() {
    if (this.state.newConnector) {
      this.setState({
        newConnector: null
      });
    }
  }

  onZoomIn() {
    const scale = Math.min(this.imageScale + this.imageScale * 0.1, 10);
    const zoom = Math.max(0, Math.min(this.state.zoom + 1, this.state.maxZoom));
    this.calculateNewPosition(scale);
    this.recalculate(zoom);
  }

  onZoomOut() {
    const scale = Math.min(this.imageScale - this.imageScale * 0.1, 10);
    const zoom = Math.max(0, Math.min(this.state.zoom - 1, this.state.maxZoom));
    this.calculateNewPosition(scale);
    this.recalculate(zoom);
  }

  onKeyDown(event) {
    if (event.keyCode === 8) {
      if (Object.keys(this.props.selectedWidget).length > 0) {
        const { projectId } = this.props.match.params;
        const connectorIds = Object.keys(this.props.connectors).reduce(
          (previous, currentKey) => {
            const tmp = previous;
            if (
              this.props.connectors[currentKey].startWidget.key ===
                this.props.selectedWidget ||
              this.props.connectors[currentKey].endWidget.key ===
                this.props.selectedWidget
            ) {
              tmp.push(currentKey);
            }
            return tmp;
          },
          []
        );
        this.props.removeConnectors(connectorIds, projectId);
        this.props.removeWidget(this.props.selectedWidget, projectId);
      }
    }
  }

  getImageScale(imageScale = 0.1) {
    let newImageScale = imageScale;
    if (
      this.imageWidth / this.imageHeight <
      this.editorWidth / this.editorHeight
    ) {
      if (this.imageHeight * newImageScale < this.editorHeight) {
        newImageScale = this.editorHeight / this.imageHeight;
      }
    } else if (this.imageWidth * newImageScale < this.editorWidth) {
      newImageScale = this.editorWidth / this.imageWidth;
    }

    return newImageScale;
  }

  calculateNewPosition(scale) {
    const percentage = scale / this.imageScale;
    this.imageScale = scale;
    const originX = this.editorWidth / 2;
    const originY = this.editorHeight / 2;
    const box = this.container.getBoundingClientRect();
    const posX = box.left + box.width * 0.5;
    const posY = box.top + box.height * 0.5;

    const offsetX = (posX - originX) * percentage - (posX - originX);
    const offsetY = (posY - originY) * percentage - (posY - originY);

    this.imagePositionX =
      (this.container.offsetLeft + offsetX) / this.editorWidth;
    this.imagePositionY =
      (this.container.offsetTop + offsetY) / this.editorHeight;
  }

  recalculate(zoom = null, state) {
    const {
      imagePositionX,
      imagePositionY,
      imageScale,
      imageHeightWithEmptySpace,
      imageWidthWithEmptySpace
    } = this.fitMap();

    this.setState({
      imagePositionX,
      imagePositionY,
      imageScale,
      minimapHeightPercentage: this.editorHeight / imageHeightWithEmptySpace,
      minimapWidthPercentage: this.editorWidth / imageWidthWithEmptySpace,
      positionXPercentage:
        ((this.editorWidth * imagePositionX) / imageWidthWithEmptySpace) * -1 +
        0.5,
      positionYPercentage:
        ((this.editorHeight * imagePositionY) / imageHeightWithEmptySpace) *
          -1 +
        0.5,
      zoom: zoom || this.state.zoom,
      ...state
    });
  }

  widgetOnMouseDrop(widget) {
    if (this.state.newConnector) {
      this.state.newConnector.endWidget = { ...widget, id: null };
      if (
        this.state.newConnector.startWidget.key !==
          this.state.newConnector.endWidget.key &&
        !this.isConnectorExist(
          this.state.newConnector.startWidget,
          this.state.newConnector.endWidget
        )
      ) {
        const newConnector = getDataFromModel(
          this.state.newConnector,
          mapConnectorModel
        );
        const { projectId } = this.props.match.params;
        this.props.addConnector(newConnector, projectId);
      }
    }
  }

  widgetOnMouseUp(widget) {
    const { widgets, connectors } = this.state;
    const newWidgets = Object.keys(widgets).reduce((obj, key) => {
      const tmp = obj;
      tmp[key] = widgets[key];
      if (widgets[key].sceneId === widget.sceneId) {
        tmp[key] = widget;
      }
      return tmp;
    }, {});
    const newConnectors = Object.keys(connectors).reduce((obj, key) => {
      const newConnector = connectors[key];
      const tmpObj = obj;
      if (newConnector.startWidget.sceneId === widget.sceneId) {
        newConnector.startWidget = { ...widget, id: null };
      }

      if (newConnector.endWidget.sceneId === widget.sceneId) {
        newConnector.endWidget = { ...widget, id: null };
      }
      tmpObj[key] = newConnector;
      return tmpObj;
    }, {});
    this.setState({ widgets: newWidgets, connectors: newConnectors });
    const { projectId } = this.props.match.params;
    this.props.updateMap(newWidgets, newConnectors, projectId);
  }

  isConnectorExist(startWidget, endWidget) {
    for (const [key, connector] of Object.entries(this.state.connectors)) {
      if (
        (startWidget.key === this.state.connectors[key].startWidget.key &&
          endWidget.key === this.state.connectors[key].endWidget.key) ||
        (startWidget.key === this.state.connectors[key].endWidget.key &&
          endWidget.key === this.state.connectors[key].startWidget.key)
      ) {
        return true;
      }
    }

    return false;
  }

  widgetOnStartConnect(widget) {
    window.addEventListener("mousemove", this.connectorOnMouseMove);
    window.addEventListener("mouseup", this.connectorOnMouseUp);

    const connector = {
      startWidget: { ...widget, id: null },
      startPositionX: widget.positionX,
      startPositionY: widget.positionY,
      endPositionX: widget.positionX,
      endPositionY: widget.positionY
    };
    this.setState({
      newConnector: connector
    });
  }

  widgetOnChangePosition(widget, event) {
    const { widgets, connectors } = this.props;
    const newWidgets = Object.keys(widgets).reduce((obj, key) => {
      const tmp = obj;
      tmp[key] = widgets[key];
      if (widgets[key].id === widget.id) {
        tmp[key] = widget;
      }
      return tmp;
    }, {});
    const newConnectors = Object.keys(connectors).reduce((obj, key) => {
      const newConnector = connectors[key];
      const tmpObj = obj;
      if (newConnector.startWidget.sceneId === widget.sceneId) {
        newConnector.startWidget = { ...widget, id: null };
      }

      if (newConnector.endWidget.sceneId === widget.sceneId) {
        newConnector.endWidget = { ...widget, id: null };
      }
      tmpObj[key] = newConnector;
      return tmpObj;
    }, {});
    this.setState({
      widgets: newWidgets,
      connectors: newConnectors
    });
  }

  widgetOnSelect(widget) {
    const { projectId } = this.props.match.params;
    const { sceneId } = this.props.widgets[widget];
    this.props.selectWidget(widget);
    this.props.selectInspectorItem(widget, EDITOR_ITEMS.MAP_WIDGET);
    this.props.push(`/map-editor/${projectId}/${sceneId}`);
  }

  addPortal(item, position) {
    const widgets = this.props.widgets;
    const foundWidget = Object.entries(widgets).find(
      ([key, widget]) => widget.sceneId === item.id
    );
    if (!foundWidget) {
      const isMain = Object.keys(this.props.widgets).length === 0;
      const box = this.container.getBoundingClientRect();
      let positionX = (position.x - box.x) / box.width;
      let positionY = (position.y - box.y) / box.height;
      if (positionX < 0 || positionX > 1 || positionY < 0 || positionY > 1) {
        positionX = Math.min(Math.max(positionX, 0), 1);
        positionY = Math.min(Math.max(positionY, 0), 1);
        positionX = 0.5;
        positionY = 0.5;
      }
      const widget = {
        positionX,
        positionY,
        positionZ: 165,
        type: WIDGETS.PORTAL,
        sceneId: item.id,
        isMain
      };
      const { projectId } = this.props.match.params;
      this.props.addPortal(widget, projectId);
    }
  }

  fitMap() {
    this.imageScale = this.getImageScale(this.imageScale);
    const imageWidthWithEmptySpace =
      this.imageWidth * this.imageScale +
      Math.max(
        0,
        (this.editorWidth - this.imageWidth * this.initialScale) *
          this.imageScale
      );
    const imageHeightWithEmptySpace =
      this.imageHeight * this.imageScale +
      Math.max(
        0,
        (this.editorHeight - this.imageHeight * this.initialScale) *
          this.imageScale
      );

    this.imagePositionX = Math.min(
      Math.max(
        this.imagePositionX,
        0.5 -
          ((imageWidthWithEmptySpace - this.editorWidth) / this.editorWidth) *
            0.5
      ),
      0.5 +
        ((imageWidthWithEmptySpace - this.editorWidth) / this.editorWidth) * 0.5
    );
    this.imagePositionX =
      imageWidthWithEmptySpace < this.editorWidth ? 0.5 : this.imagePositionX;
    this.imagePositionY = Math.min(
      Math.max(
        this.imagePositionY,
        0.5 -
          ((imageHeightWithEmptySpace - this.editorHeight) /
            this.editorHeight) *
            0.5
      ),
      0.5 +
        ((imageHeightWithEmptySpace - this.editorHeight) / this.editorHeight) *
          0.5
    );
    this.imagePositionY =
      imageHeightWithEmptySpace < this.editorHeight ? 0.5 : this.imagePositionY;

    return {
      imagePositionX: this.imagePositionX,
      imagePositionY: this.imagePositionY,
      imageScale: this.imageScale,
      imageWidthWithEmptySpace,
      imageHeightWithEmptySpace
    };
  }

  imageOnLoad({ target: img }) {
    this.imageWidth = img.naturalWidth;
    this.imageHeight = img.naturalHeight;
    this.editorWidth = this.editor.offsetWidth;
    this.editorHeight = this.editor.offsetHeight;
    let scale = null;

    if (
      this.imageWidth / this.imageHeight <
      this.editorWidth / this.editorHeight
    ) {
      scale = this.editorHeight / this.imageHeight;
    } else {
      scale = this.editorWidth / this.imageWidth;
    }

    const initialScale = scale;
    this.initialScale = initialScale;
    this.imageScale = initialScale;
    this.recalculate();

    let maxZoom = 0;

    while (1) {
      const temp = scale * 1.1;
      if (temp < 10) {
        scale = temp;
        maxZoom += 1;
      } else {
        break;
      }
    }

    this.setState({
      imageLoaded: true,
      initialScale,
      imageScale: initialScale,
      imageWidth: this.imageWidth,
      imageHeight: this.imageHeight,
      refreshMinimap: true,
      imageNaturalHeight: img.naturalHeight,
      imageNaturalWidth: img.naturalWidth,
      maxZoom
    });
    this.props.onImageLoad(img.naturalWidth, img.naturalHeight);
  }

  connectorOnMouseMove(event) {
    event.preventDefault();
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const box = this.container.getBoundingClientRect();
    const endPositionX = (mouseX - box.left) / box.width;
    const endPositionY = (mouseY - box.top) / box.height;
    this.state.newConnector.endPositionX = endPositionX;
    this.state.newConnector.endPositionY = endPositionY;
    this.setState({
      newConnector: this.state.newConnector
    });
  }

  connectorOnMouseUp(event) {
    event.preventDefault();
    window.removeEventListener("mousemove", this.connectorOnMouseMove);
    window.removeEventListener("mouseup", this.connectorOnMouseUp);
  }

  renderMinimap(mapImageUrl) {
    return (
      <Minimap
        editorWidth={this.editorWidth}
        editorHeight={this.editorHeight}
        imageScale={this.state.imageScale}
        initialScale={this.state.initialScale}
        imageWidth={this.state.imageWidth}
        imageHeight={this.state.imageHeight}
        imageNaturalHeight={this.state.imageNaturalHeight}
        imageNaturalWidth={this.state.imageNaturalWidth}
        minimapHeightPercentage={this.state.minimapHeightPercentage}
        minimapWidthPercentage={this.state.minimapWidthPercentage}
        positionXPercentage={this.state.positionXPercentage}
        positionYPercentage={this.state.positionYPercentage}
        onZoomIn={this.onZoomIn}
        onZoomOut={this.onZoomOut}
        zoom={this.state.zoom}
        maxZoom={this.state.maxZoom}
        onMouseMove={this.onMinimapMove}
        onClick={this.onMinimapClick}
      />
    );
  }

  renderConnector(connector) {
    return (
      <MapConnector
        {...connector}
        containerRef={this.container}
        onConnectorRemove={this.onConnectorRemove}
      />
    );
  }

  renderWidget(id, widget) {
    return (
      <MapWidget
        key={id}
        id={id}
        object={widget}
        selected={
          this.props.selectedWidget ? this.props.selectedWidget === id : null
        }
        onSelect={this.widgetOnSelect}
        onChangePosition={this.widgetOnChangePosition}
        onStartConnect={this.widgetOnStartConnect}
        onMouseDrop={this.widgetOnMouseDrop}
        onMouseUp={this.widgetOnMouseUp}
        onKeyDown={this.onKeyDown}
        {...widget}
      >
        {widget.type === "portal" ? "" : ""}
      </MapWidget>
    );
  }

  render() {
    const { connectDropTarget, mapImageUrl } = this.props;
    const imageWidth = Math.round(this.imageWidth * this.state.imageScale);
    const imageHeight = Math.round(this.imageHeight * this.state.imageScale);

    // rewrite objects in redux to have id and key
    prepareItems(idx(this.props, _ => _.map.widgets));
    prepareItems(idx(this.props, _ => _.map.connectors));

    const displayStyle =
      this.state.imageLoaded && !this.props.isUploading
        ? { display: "block" }
        : { display: "none" };

    return connectDropTarget(
      <div
        role="presentation"
        tabIndex="-1"
        className="JumperMapEditor"
        style={Styles.divStyle(this.state.display)}
        ref={editor => {
          this.editor = editor;
        }}
        onWheel={this.onWheel}
        onMouseUp={this.onDropConnector}
      >
        {((!this.state.imageLoaded && !!mapImageUrl) ||
          this.props.isUploading) && (
          <Spinner
            name="ball-triangle-path"
            fadeIn="none"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%"
            }}
          />
        )}
        {this.state.imageLoaded &&
          !this.props.isUploading &&
          this.renderMinimap(mapImageUrl)}
        <div
          role="presentation"
          className="Container"
          ref={container => {
            this.container = container;
          }}
          style={[
            Styles.containerStyle(
              imageWidth,
              imageHeight,
              this.state.imagePositionX,
              this.state.imagePositionY
            ),
            displayStyle
          ]}
          onMouseDown={this.onMouseDown}
        >
          <MapImage
            imageUrl={mapImageUrl}
            onLoad={this.imageOnLoad}
            unselectable="on"
            alt=""
            imageWidth={imageWidth}
            imageHeight={imageHeight}
          />
          {this.state.newConnector &&
            this.renderConnector(this.state.newConnector)}
          {this.state.connectors &&
            Object.entries(this.state.connectors).map(([id, connector]) =>
              this.renderConnector(connector, id)
            )}
          {this.state.widgets &&
            Object.entries(this.state.widgets).map(([id, widget]) =>
              this.renderWidget(id, widget)
            )}
        </div>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.onResize}
          skipOnMount
        />
      </div>
    );
  }
}
Map.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  mapImageUrl: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => ({
  push: path => {
    dispatch(push(path));
  },
  addPortal: (portal, projectId) => {
    dispatch(addPortalRequest(portal, projectId));
  },
  selectWidget: widget => {
    dispatch(selectWidget(widget));
  },
  selectInspectorItem: (id, itemType) => {
    dispatch(selectInspectorItem(id, itemType));
  },
  addConnector: (connector, projectId) => {
    dispatch(addConnectorRequest(connector, projectId));
  },
  updateWidget: (widget, projectId) => {
    dispatch(updateWidgetRequest(widget, projectId));
  },
  updateMap: (widgets, connectors, projectId) => {
    dispatch(updateMapRequest(widgets, connectors, projectId));
  },
  removeWidget: (widget, projectId) => {
    dispatch(removeWidget(widget, projectId));
  },
  removeConnectors: (connectors, projectId) => {
    dispatch(removeConnectors(connectors, projectId));
  },
  removeConnector: (connectorId, projectId) => {
    dispatch(removeConnector(connectorId, projectId));
  },
  removeWidgetLocally: (widgetId, projectId) => {
    dispatch(removeWidgetLocally(widgetId, projectId));
  },
  removeConnectorLocally: (connectorId, projectId) => {
    dispatch(removeConnectorLocally(connectorId, projectId));
  }
});

function mapStateToProps({ firebase, map }) {
  const { selectedWidget = "", widgets = {}, connectors = {} } = map;
  const { map: firebaseMap = {} } = firebase.data;
  return {
    firebaseMap: firebaseMap || {},
    organizations: firebase.data.organizations,
    projects: firebase.data.projects,
    map,
    widgets,
    connectors,
    selectedWidget
  };
}

function collect(dropConnect) {
  return {
    connectDropTarget: dropConnect.dropTarget()
  };
}

const containerTarget = {
  drop(props, monitor, target) {
    target.addPortal(monitor.getItem(), monitor.getClientOffset());
  }
};

export default compose(
  withFirebase,
  connect(({ firebase, organizations }) => ({
    auth: firebase.auth,
    currentOrganizationId: organizations.currentOrganizationId
  })),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  DropTarget(Types.WIDGET, containerTarget, collect)
)(Radium(Map));



// WEBPACK FOOTER //
// ./src/containers/MapEditor/MapContainer.js